<template>

  <div class="product">
    <!--内容-->
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="搜索条件">
          <el-input v-model="formInline.search" placeholder="用户ID/订单号"></el-input>
        </el-form-item>

        <el-form-item label="支付状态">
          <el-select size="small" v-model="formInline.pay_status" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="已付款" value="20"></el-option>
            <el-option label="未付款" value="10"></el-option>
            <el-option label="已退款" value="30"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="back">返回上一页</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData"  border style="width: 100%" v-loading="loading">
          <!-- <el-table-column type="selection"></el-table-column> -->
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main">订单号：{{ scope.row.order_no }}</span><br />
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope">
              <div class="orange">{{ scope.row.pay_price }}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="买家">
            <template slot-scope="scope">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_text" label="支付方式">
            <template slot-scope="scope">
              <span class="gray9">{{ scope.row.pay_text }}</span>
            </template>
          </el-table-column>

           <el-table-column prop="order_text" label="核销状态">
            <template slot-scope="scope">
              <span class="gray9">{{ scope.row.order_text }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="refund_time" label="申请退款时间"></el-table-column>

          <el-table-column prop="is_refund" label="退款状态">
            <template slot-scope="scope">
              <span class="gray9" v-if="scope.row.is_refund == 0">未申请</span>
              <span class="gray9" v-if="scope.row.is_refund == 1">审核中</span>
              <span class="gray9" v-if="scope.row.is_refund == 2">通过</span>
              <span class="gray9" v-if="scope.row.is_refund == 3">未通过</span>
            </template>
          </el-table-column>

          <el-table-column prop="reject_val" label="未通过原因"></el-table-column>


          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              <div v-if="scope.row.remark">
                  <div v-for="(item,index) in scope.row.remark"  :key="index">
                      <div v-if="index=='name'">姓名：{{item}}</div>
                      <div v-if="index=='mobile'">手机：{{item}}</div>
                      <div v-if="index=='num'">人数：{{item}}人</div>
                   
                      <div v-if="index=='time'">场次：{{item}}</div>
                      <div v-if="index=='remark'">备注：{{item}}</div>
                  </div>
              </div>
            </template>
          </el-table-column>


          <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <!-- <el-button  @click="joinClick(scope.row)" type="text" size="small">参与人员</el-button><br /> -->
                <el-button v-if="scope.row.is_refund == 1" @click="passClick(scope.row)" type="text" size="small">通过退款申请</el-button><br />
                <el-button v-if="scope.row.is_refund == 1" @click="nopassClick(scope.row)" type="text" size="small">不通过退款申请</el-button><br />

              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
    
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        pay_status:"20"
      },

    };
  },
  created() {
    this.activity_id = this.$route.query.activity_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.activity_id = self.activity_id;
      self.loading = true;
      activityApi.detail(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    joinClick(row){
      let activity_id = row.activity_id;
      let user_id = row.user_id;
       this.$router.push({
        path: '/plus/activity/activity/identity',
        query: {
          activity_id: activity_id,
          user_id:user_id,
          activity_record_id:row.activity_record_id

        }
      });
    },
    async passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        activity_record_id:item.activity_record_id,
        status:2,
        price:0,
        refund_type:item.refund_type
      }
      console.log(item)
      if(item.refund_type == 3 && item.pay_price > 0){
        const reject_val = await this.promptInput('用户支付金额：'+item.pay_price+'元'+';请输入退款金额', '请输入退款金额');
          Params.price = reject_val
          if(reject_val == undefined){
            console.log("取消")
          }else{
              console.log(Params)
              if(reject_val.length > 0){
                activityApi.passCanel(Params, true)
                          .then(data => {
                            if(data.code == 1){
                              self.$message({
                                  type: 'success',
                                  message: '审核成功'
                              });
                                self.getTableList();
                                return false;
                            }
                          })
                          .catch(error => {});
              }else{
                this.$message({
                  type: 'error',
                  message: '请输入退款金额',
                });
              }

          }
      }else{
        activityApi.passCanel(Params, true)
                .then(data => {
                  console.log(data)
                  if(data.code == 1){
                    self.$message({
                        type: 'success',
                        message: '审核成功'
                    });
                      self.getTableList();
                      return false;
                  }
                })
                .catch(error => {
                  
                
                });
      }
      

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('用户取消原因：【'+item.canel_val+'】'+';请输入不通过的原因', '请输入不通过的原因');

      var Params = {
        activity_record_id:item.activity_record_id,
        status:3,
        reject_val:reject_val
      }
      console.log(reject_val)
      if(reject_val == undefined){
        console.log("取消")
      }else{
          if(reject_val.length > 0){
            activityApi.passCanel(Params, true)
                      .then(data => {
                        if(data.code == 1){
                          self.$message({
                              type: 'success',
                              message: '审核成功'
                          });
                            self.getTableList();
                            return false;
                        }
                      })
                      .catch(error => {});
          }else{
            this.$message({
              type: 'error',
              message: '请输入不通过的原因',
            });
          }
  
      }
     
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },

    back(){
       this.$router.push({
        path: '/plus/activity/index'
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/detail.vue